module.exports = __webpack_public_path__ + "img/public/SiteIcons/shareLoveIcon.png?7da316f1";